import { renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e4de0dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "buttons"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "submit-wrapper"
}
const _hoisted_5 = ["aria-label", "disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Door op 'plaats nu je melati' te klikken bevestig je het "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/content/privacy",
    target: "_blank"
  }, "privacybeleid"),
  /*#__PURE__*/_createTextVNode(" te hebben gelezen en begrepen ")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "characters"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade-melati" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["step", { blur: _ctx.currentStep > _ctx.stepNumber }])
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 2), [
          [_vShow, _ctx.show]
        ])
      ]),
      _: 3
    }),
    (_ctx.currentStep === _ctx.stepNumber && _ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.currentStep > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "back-btn",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('previous')), ["prevent"])),
                disabled: _ctx.submitted
              }, " Vorige ", 8, _hoisted_2))
            : _createCommentVNode("", true),
          (_ctx.currentStep !== 4)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "next outline-btn",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('next')), ["prevent"])),
                disabled: _ctx.disableButton
              }, " Volgende ", 8, _hoisted_3))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade-melati-delay" }, {
      default: _withCtx(() => [
        (_ctx.currentStep === 4 && _ctx.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("input", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                type: "submit",
                class: "submit solid-btn",
                value: "Plaats nu je melati",
                "aria-label": _ctx.submitButtonAriaLabel,
                disabled: _ctx.submitted,
                ref: "focus"
              }, null, 8, _hoisted_5),
              _hoisted_6
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade-melati" }, {
      default: _withCtx(() => [
        (_ctx.currentStep === 1 && _ctx.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(_ctx.charactersUsed) + " / 400", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}